/**
 * GA4 Support for Rebuy Cart Drawer
 *
 * When the rebuy cart is enabled on the site, the normal <cart-drawer> that our
 * base theme uses is not active, and therefore the GA4 events inside of the
 * <cart-drawer> web component do not fire.
 *
 * This script manually adds event listeners that ensure dataLayer events for
 * GA4 fire for the rebuy cart as well.
 */
window.addEventListener('load', () => {

  /**
   * Rebuy: Smart Cart Event Listener - rebuy:smartcart.product-removed
   *
   * This method fires when the a product is removed through Rebuy's cart widget.
   */
  document.addEventListener('rebuy:smartcart.product-removed', (event) => {
    const cart = event?.detail?.smartcart?.cart;
    const product = event?.detail?.product;
    if(typeof event?.detail?.product === 'object' && typeof cart.currency === 'string' && cart.currency.length) {
      const {product_id: item_id, variant_id: item_variant, product_title: item_name, quantity, product_type: item_category} = product;
      const item = {
        item_id,
        item_name,
        item_variant,
        item_category,
        quantity,
        ...calculatePrice({
          product: product,
          product_tags: []
        })
      };
      pushDataLayerEvent({
        event: 'remove_from_cart',
        ecommerce: {
          currency: cart.currency,
          value: calculateValue([item]),
          items: [item]
        }
      });
    }
  });

  /**
   * Rebuy: Smart Cart Event Listener - rebuy:smartcart.show
   *
   * This method fires when the cart is viewed/opened, and also when it is updated with new data to be viewed,
   * such as a quantity change.
   */
  document.addEventListener('rebuy:smartcart.show', (event) => {
    /**
     * GA4 DataLayer Event: View Cart
     * @see https://developers.google.com/analytics/devguides/collection/ga4/reference/events?client_type=gtm#view_cart
     */
    try {
      const cart = event?.detail?.smartcart?.cart;
      const cartItems = event?.detail?.smartcart?.cart?.items;
      if(Array.isArray(cartItems) && typeof cart.currency === 'string' && cart.currency.length) {
        const items = cartItems.map(product => {
          const {product_id: item_id, variant_id: item_variant, product_title: item_name, product_type: item_category, quantity} = product;
          return {
            item_id,
            item_name,
            item_variant,
            item_category,
            quantity,
            ...calculatePrice({
              product,
              product_tags: []
            })
          };
        });
        pushDataLayerEvent({
          event: 'view_cart',
          ecommerce: {
            currency: cart.currency,
            value: calculateValue(items),
            items: items
          },
        });
      }
    } catch (error) {
      console.log('GA4: view_cart', error);
    }
  });
});
